module.exports = __webpack_public_path__ + "static/Ccards22-f0867a8cf7c519f4aefa498d5fb7353c.png";